'use client';
import cn from 'classnames';
import { Visibility } from 'components/ui-kit/visibility';
import { TProductResponse } from 'lib';
import { useState, type JSX } from 'react';
import { Categories } from './blocks/categories.component';
import { HeroMobileBlock } from './blocks/hero-mobile.block';
import { HeroBlock } from './blocks/hero.block';
import { ProductsBlock } from './blocks/products.block';
import { Quiz } from './blocks/quiz/quiz.component';
import styles from './collaboration-utkonos-page.module.scss';

type TCollaborationUtkonosProps = {
  products: Array<TProductResponse>;
};
export const CollaborationUtkonos = ({
  products,
}: TCollaborationUtkonosProps): JSX.Element => {
  const [isDoneQuiz, setIsDoneQuiz] = useState(false);
  const [score, setScore] = useState(0);

  return (
    <div className={styles.page}>
      <section className={cn(styles.hero, styles.section)}>
        <Visibility visible="m">
          <HeroBlock />
        </Visibility>
        <Visibility hidden="m">
          <HeroMobileBlock />
        </Visibility>
      </section>

      <section className={styles.section}>
        <Quiz
          onFinish={(result: number) => {
            setIsDoneQuiz(true);
            setScore(result);
          }}
        />
      </section>

      {isDoneQuiz ? (
        <>
          <section className={styles.section}>
            <ProductsBlock products={products} score={score} />
          </section>

          <section className={styles.section}>
            <Categories />
          </section>
        </>
      ) : null}
    </div>
  );
};
